import Cookies from 'js-cookie'

const Newsletter = () => {
  const $body = $('body')
  const $newsletters = $body.find('[data-name="newsletter"]')

  if (Cookies.get('newsletter')) {
    $newsletters.remove()
  }
}

export default Newsletter



// WEBPACK FOOTER //
// ./scripts/components/Newsletter.js